import axios from "axios";
import API from "./../../api";
import API_CONFIG from "@safecv/src/api-config";
import {
  USER_NAME_SESSION_ATTRIBUTE_NAME,
  TOKEN_SESSION_ATTRIBUTE_NAME,
  ROLE_SESSION_ATTRIBUTE_NAME,
  PROFILE_PREFERENCE,
  REVIEWER_NAME_SESSION_ATTRIBUTE_NAME,
  IS_CC_USER,
} from "@safecv/shared/appConstant";
import history from "@safecv/shared/history";

import { Auth } from "aws-amplify";

class AuthenticationService {
  executeBasicAuthenticationService(username, password) {
    var formData = new FormData();
    formData.append("username", username);
    formData.append("password", password);
    formData.append("grant_type", "password");

    return axios.post(API.TOKEN, formData, {
      auth: {
        username: API_CONFIG.API_CLIENT_ID,
        password: API_CONFIG.API_CLIENT_SECRET,
      },
      headers: {
        "content-type": "multipart/form-data",
      },
    });
  }

  CCExecuteBasicAuthenticationService(username, password, reviewer) {
    return axios.get(API.PROFILE.JWT + "?userId=" + window.atob(reviewer), {
      auth: {
        username: username,
        password: password,
      },
    });
  }

  validateEmail(email) {
    const re =
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(email).toLowerCase());
  }

  async isCCUser(url) {
    let referrer = document.referrer,
      referrerMatched = false,
      validURL = false,
      reviewerhasAccess = false,
      reviewer = null;

    url = decodeURIComponent(url);

    // if (url && referrer.match(/^https?:\/\/([^\/]+\.)?localhost:3000(\/|$)/i)) {
    if (
      url &&
      referrer.match(/^https?:\/\/([^\/]+\.)?communitycore\.com(\/|$)/i)
    ) {
      referrerMatched = true;
      let processedURL = url.match(
        /^\/plan\/([^\/]+)?\/pdfviewer\?reviewer=([^\/]+)?(\/|$)/i
      );

      validURL =
        Array.isArray(processedURL) &&
        !isNaN(processedURL[1]) &&
        !isNaN(parseFloat(processedURL[1])) &&
        this.validateEmail(window.atob(processedURL[2]));
      reviewer = validURL && processedURL[2];

      if (validURL)
        reviewerhasAccess = await axios
          .get(
            API.PROFILE.ACCESS(processedURL[1]) +
              "?userId=" +
              window.atob(processedURL[2])
          )
          .then((res) => {
            if (res.status && res.status === 200) {
              return true;
            } else return false;
          });
    }

    return [referrerMatched && reviewerhasAccess, reviewer];
  }

  fetchProfileData(token) {
    return axios.get(API.PROFILE.DETAILS, {
      headers: {
        Authorization: "Bearer " + token,
      },
    });
  }

  fetchPreference(token) {
    return axios.get(API.PROFILE.PREFERENCE, {
      headers: {
        Authorization: "Bearer " + token,
      },
    });
  }

  fetchNotifications(token) {
    return axios.get(API.PROFILE.NOTIFICATIONS, {
      headers: {
        Authorization: "Bearer " + token,
      },
    });
  }

  registerSuccessfulLogin(responseData) {
    let token = "Bearer " + responseData;
    localStorage.setItem(TOKEN_SESSION_ATTRIBUTE_NAME, token);
    this.setupAxiosInterceptors(token);
  }

  logout() {
    localStorage.removeItem(USER_NAME_SESSION_ATTRIBUTE_NAME);
    let user = localStorage.getItem(USER_NAME_SESSION_ATTRIBUTE_NAME);
    localStorage.removeItem(TOKEN_SESSION_ATTRIBUTE_NAME);
    let token = localStorage.getItem(USER_NAME_SESSION_ATTRIBUTE_NAME);
    localStorage.removeItem(ROLE_SESSION_ATTRIBUTE_NAME);
    let role = localStorage.getItem(ROLE_SESSION_ATTRIBUTE_NAME);
    localStorage.removeItem(PROFILE_PREFERENCE);
    localStorage.removeItem(REVIEWER_NAME_SESSION_ATTRIBUTE_NAME);
    localStorage.removeItem(IS_CC_USER);

    if (API_CONFIG.FEATURE_REVIEWER_SSO_ENABLED) {
      Auth.signOut();
    }
    if (user === null && token === null && role === null)
      return (window.location.href = "/");
  }

  //this method is needed to check token existence and register it even during screen refresh
  isUserLoggedInAndTokenRegistered() {
    if (!this.isUserLoggedIn()) {
      return false;
    }
    if (
      API_CONFIG.FEATURE_REVIEWER_SSO_ENABLED &&
      !localStorage.getItem(IS_CC_USER)
    ) {
      this.setupAxiosInterceptorsSSO();
    } else {
      let token = localStorage.getItem(TOKEN_SESSION_ATTRIBUTE_NAME);
      this.setupAxiosInterceptors(token);
    }
    return true;
  }

  isUserLoggedIn() {
    let user = localStorage.getItem(USER_NAME_SESSION_ATTRIBUTE_NAME);
    if (user === null) return false;
    return true;
  }

  getLoggedInUserName() {
    let user = localStorage.getItem(USER_NAME_SESSION_ATTRIBUTE_NAME);
    if (user === null) return "";
    return user;
  }

  setupAxiosInterceptorsSSO() {
    axios.interceptors.request.use(async (config) => {
      let result = await Auth.currentAuthenticatedUser();
      config.headers.authorization =
        "Bearer " + result.signInUserSession.idToken.jwtToken;
      localStorage.setItem(
        TOKEN_SESSION_ATTRIBUTE_NAME,
        config.headers.authorization
      );
      return config;
    });
    axios.interceptors.response.use(
      (response) => {
        return response;
      },
      (error) => {
        if (error.response?.status === 401) {
          this.logout();
        }
        return error;
      }
    );
  }

  setupAxiosInterceptors(token) {
    axios.interceptors.request.use((config) => {
      if (this.isUserLoggedIn()) {
        config.headers.authorization = token;
      }
      return config;
    });
    axios.interceptors.response.use(
      (response) => {
        return response;
      },
      (error) => {
        if (error?.response?.status === 403) {
          history.push({
            pathname: "/error",
            // state: { message: error.response.data.message, error: error.response.data.error }
          });
        } else if (error.response?.status === 401) {
          this.logout();
        }
        return error;
      }
    );
  }
}

export default new AuthenticationService();
